import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
      <g transform="translate(13.000000, 15.000000)">
      <path
        d="M24.8558 49.72C18.7598 49.72 14.0318 47.608 10.6718 43.384C7.31178 39.16 5.63178 33.28 5.63178 25.744C5.63178 18.112 7.45578 12.184 11.1038 7.96C14.7518 3.688 19.9118 1.552 26.5838 1.552C28.7918 1.552 30.9038 1.84 32.9198 2.416C34.9838 2.992 36.7358 3.64 38.1758 4.36C39.6158 5.08 40.3358 5.464 40.3358 5.512L39.6878 8.968C39.6878 8.92 38.9918 8.56 37.5998 7.888C36.2078 7.216 34.5758 6.592 32.7038 6.016C30.8798 5.44 29.0318 5.152 27.1598 5.152C21.8318 5.152 17.8718 6.88 15.2798 10.336C12.7358 13.744 11.4638 18.88 11.4638 25.744C11.4638 32.464 12.7118 37.552 15.2078 41.008C17.7038 44.416 21.1838 46.12 25.6478 46.12C29.2478 46.12 31.8638 45.256 33.4958 43.528C35.1278 41.8 36.1838 40.072 36.6638 38.344V27.76H27.0878V24.664H41.2718V49H38.6078L37.2398 43.888C36.0878 45.568 34.5038 46.96 32.4878 48.064C30.4718 49.168 27.9278 49.72 24.8558 49.72Z" 
        fill="currentColor"/>
      </g>
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      
      </g>
    </g>
  </svg>
);

export default IconLogo;
